import { BASE_URL, s3Path } from '../../general/variables';
import { makeKTBlock, splitable, nl2br, getUrlParameter, makeSwal } from '../../general/functions';
import { createInvoiceValidation, currencyEl, universityList } from './setup';

const initEventListenerOne = () => {
  var endorseCard = new KTCard('endorseCard');
  $('#endorseSubmit').on('click', function () {
    // Mulai proses, block kartu biar ga ada input
    KTApp.block(endorseCard.getSelf(), {
      overlayColor: '#ffffff',
      type: 'loader',
      state: 'primary',
      opacity: 0.3,
      size: 'lg',
    });

    // Ambil data dari form repeater
    let endorseCollection = $('.endorse-list').repeaterVal();

    // Set form kalau kosong jadi FALSE dan falseCounter dimulai dari 0
    let formCheck = false,
      falseCounter = 0;

    // Cek kolom endorse ada yang kosong atau engga
    $.each(endorseCollection.endorseList, function (ind, val) {
      // Kalau misalnya kolom nama kosong, tambah ke variable falseCounter
      if (val.kolName == '') {
        falseCounter++;

        $(`[name="endorseList[${ind}][kolName]"]`).siblings('small').removeClass('d-none');
      } else {
        $(`[name="endorseList[${ind}][kolName]"]`).siblings('small').addClass('d-none');
      }
    });

    // Kalau URL event masih kosong, wajib dilengkapin dulu
    if ($('[name="eventUrl"]').val() == '') {
      Swal.fire({
        html: '<strong>URL Event</strong> tidak boleh kosong. Silahkan lengkapi',
        icon: 'warning',
        focusConfirm: false,
        showCancelButton: false,
        confirmButtonText: 'Lengkapi sekarang',
      }).then((res) => {
        $('#detail-tab').tab('show');
        KTApp.unblock(card.getSelf());
      });
      return;
    }

    // Blok submit form kalau misalnya masih ada kolom yang kosong
    if (falseCounter > 0) {
      Swal.fire({
        html: '<strong>Nama Endorse</strong> tidak boleh kosong. Silahkan lengkapi',
        icon: 'warning',
        focusConfirm: false,
        showCancelButton: false,
        confirmButtonText: 'Tutup',
      });

      KTApp.unblock(endorseCard.getSelf());
    } else if (falseCounter == 0) {
      // Kalau misalnya aman, mulai proses submit form
      $.post(BASE_URL + 'C_Event/postEndorseLink', $('#endorseForm').serialize(), function (resp) {
        if (resp.code == 200) {
          Swal.fire({
            html: '<strong>Proses berhasil</strong>',
            icon: 'success',
            focusConfirm: false,
            showCancelButton: false,
            confirmButtonText: 'Tutup',
          }).then((res) => {
            location.reload();
          });
        }

        // Kalau misalnya datanya ga ada perubahan, munculin warning
        else if (resp.code == 202) {
          Swal.fire({
            html: 'Silahkan <strong>Tambahkan Data Baru</strong> untuk menyimpan daftar endorsement',
            icon: 'warning',
            focusConfirm: false,
            showCancelButton: false,
            confirmButtonText: 'Tutup',
          });
          KTApp.unblock(endorseCard.getSelf());
        } else {
          Swal.fire({
            html: '<strong>Proses Gagal</strong> Silahkan coba lagi',
            icon: 'warning',
            focusConfirm: false,
            showCancelButton: false,
            confirmButtonText: 'Tutup',
          });
          KTApp.unblock(endorseCard.getSelf());
        }
      });
    }
  });

  $('#createInvoiceFile').on('change', function (e) {
    //get the file name
    var fileName = e.target.files[0].name;
    if (e.target.files[0].size > 2000000) {
      Swal.fire({
        title: 'File too large',
        text: 'Selected file is too large',
        icon: 'error',
        confirmButtonText: 'Ok',
      });

      $('#createInvoiceFile').val(null);
      setTimeout(() => {
        $(this).next('.custom-file-label').html('Choose file');
      }, 500);
    } else {
      setTimeout(() => {
        $(this).next('.custom-file-label').html(fileName);
      }, 500);
    }
  });

  $('input[name="autoItineraries"]').on('change', function () {
    if ($(this).is(':checked')) {
      $('#itineraryCollapse').collapse('show');
    } else {
      $('#itineraryCollapse').collapse('hide');
    }
  });

  $('#eventBanner').on('change', function (e) {
    var fileName = e.target.files[0].name;

    setTimeout(() => {
      $(this).next('.custom-file-label').html(fileName);
    }, 500);
  });

  $('.disabled-form').on('dblclick', function () {
    $(this).attr('readonly', false);
  });

  // Listener untuk Landing Page
  // $('#lpSubmitButton').on('click', function () {
  //   makeKTBlock('#landingPageCard', 'show', '#fff');

  //   // Ambil data dari form repeater
  //   let landingPageCollections = $('.landing-page-list').repeaterVal();

  //   let formCheck = false;
  //   let falseCounter = 0;

  //   // Cek kolom endorse ada yang kosong atau engga
  //   $.each(landingPageCollections.landingPageList, function (ind, val) {
  //     // Kalau misalnya kolom nama kosong, tambah ke variable falseCounter
  //     if (val.lpName == '') {
  //       falseCounter++;
  //     }
  //   });

  //   if (falseCounter > 0) {
  //     Swal.fire({
  //       html: '<strong>Page URL</strong> Cannot be empty!',
  //       icon: 'warning',
  //       focusConfirm: false,
  //       showCancelButton: false,
  //       confirmButtonText: 'Close',
  //     });

  //     makeKTBlock('#landingPageCard', 'hide');
  //   } else if (falseCounter == 0) {
  //     // Kalau misalnya aman, mulai proses submit form
  //     $.post(BASE_URL + 'C_Event/postLandingPageLink', $('#landpingPagesForm').serialize(), function (resp) {
  //       if (resp.code == 200) {
  //         Swal.fire({
  //           html: '<strong>Entry Created!</strong>',
  //           icon: 'success',
  //           focusConfirm: false,
  //           showCancelButton: false,
  //           confirmButtonText: 'Close',
  //         }).then((res) => {
  //           location.reload();
  //         });
  //       } else if (resp.code == 202) {
  //         // Kalau misalnya datanya ga ada perubahan, munculin warning
  //         Swal.fire({
  //           html: 'Please enter <strong>New Values</strong> to save Page List',
  //           icon: 'warning',
  //           focusConfirm: false,
  //           showCancelButton: false,
  //           confirmButtonText: 'Tutup',
  //         });

  //         makeKTBlock('#landingPageCard', 'hide');
  //       } else {
  //         Swal.fire({
  //           html: '<strong>Process Failed</strong> Please try again later',
  //           icon: 'warning',
  //           focusConfirm: false,
  //           showCancelButton: false,
  //           confirmButtonText: 'Tutup',
  //         });

  //         makeKTBlock('#landingPageCard', 'hide');
  //       }
  //     });
  //   }
  // });

  $('#editPaymentFile').on('change', function (e) {
    //get the file name
    var fileName = e.target.files[0].name;
    if (e.target.files[0].size > 2000000) {
      Swal.fire({
        title: 'File too large',
        text: 'Selected file is too large',
        icon: 'error',
        confirmButtonText: 'Ok',
      });

      $('#editPaymentFile').val(null);
      setTimeout(() => {
        $(this).next('.custom-file-label').html('Choose file');
      }, 500);
    } else {
      setTimeout(() => {
        $(this).next('.custom-file-label').html(fileName);
      }, 500);
    }
  });

  $(document).on('click', '.quickAddVendor', function (e) {
    e.preventDefault();

    $('#modalVendor').modal('show');

    $('.modal-backdrop').each(function (index, elem) {
      let lastIndex = $('.modal-backdrop').length;
      if (index == lastIndex - 1) {
        $('#modal_form_budget').removeClass('z-index-1045').addClass('z-index-1045');
        $(elem).removeClass('z-index-1049').addClass('z-index-1049');
      }
    });
  });

  $('#bcp_name').on('select2:select', function (e) {
    e.preventDefault();

    makeKTBlock('#section-bcp');

    $.ajax({
      url: `${BASE_URL}Expo_Packages/getEmployeeDetail`,
      type: 'GET',
      dataType: 'JSON',
      data: { employee_id: e.params.data.employee_id },
      success: function (response) {
        const { code, header, message, status, data } = response;

        if (code == 500) {
          Swal.fire({ title: header, html: message, icon: status });
        } else {
          if (data) {
            if (data.BRANCH_ID) {
              let opt1 = new Option(data.BRANCH_NAME, data.BRANCH_NAME, true, true);
              $('#bcp_branch').append(opt1).trigger('change');
            }

            $('#bcp_phone').val(data.MOBILE ?? '');
            $('#bcp_address').text(data.BRANCH_LOC ?? '');
          }
        }

        setTimeout(() => {
          makeKTBlock('#section-bcp', 'hide');
        }, 800);
      },
      error: function (error) {
        makeKTBlock('#section-bcp', 'hide');
        const { code, header, message, status } = error;
        Swal.fire({ title: header, html: message, icon: status });
      },
    });
  });

  /** Price Section */
  $('#btnAddPrices').on('click', function () {
    $(currencyEl).fadeIn(500).insertBefore('#currencyRow');

    $('.selectpicker').selectpicker('refresh');

    $('.package-prices').mask('#.##0', {
      reverse: true,
    });
  });

  $(document).on('click', '.btn-delete-packages', function () {
    let curRow = $(this).parentsUntil('.duplicate-packages').parent();

    curRow.remove();
  });

  // Export Data
  $('#btnExportSeminar').on('click', function () {
    KTApp.block('body', {
      opacity: 0.1,
      state: 'primary',
      message: 'Compiling Data...',
    });

    const curBtn = $(this);

    curBtn.attr('disabled', true);

    $.ajax({
      url: BASE_URL + 'C_Event/exportSeminarList',
      method: 'POST',
      data: {
        schedule: getUrlParameter('id'),
      },
      xhrFields: {
        responseType: 'blob',
      },
      success: function (data) {
        Swal.fire({
          html: 'Data Exported!',
          icon: 'success',
          showCancelButton: false,
          confirmButtonText: 'Close',
        });

        curBtn.attr('disabled', false);
        KTApp.unblock('body');

        const a = document.createElement('a');
        const url = window.URL.createObjectURL(data);
        a.href = url;
        a.download = 'Seminar Participants.xlsx';
        document.body.append(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      },
      error: function (_data) {
        Swal.fire({
          title: 'Network Problem Detected!',
          html: 'Cannot create file, please try again later!',
          icon: 'error',
          showCancelButton: false,
          confirmButtonText: 'Close',
        });

        curBtn.attr('disabled', false);
        KTApp.unblock('body');
      },
    });
  });

  $('#btnExportConsultation').on('click', function () {
    KTApp.block('body', {
      opacity: 0.1,
      state: 'primary',
      message: 'Compiling Data...',
    });

    let curBtn = $(this);

    curBtn.attr('disabled', true);

    if ($('[name="eventID"]').val() == '' || $('[name="eventID"]').val() == null) {
      Swal.fire({
        title: 'Process Failed!',
        icon: 'error',
        html: 'Please enter <strong>"EVENT ID"</strong> to continue! ',
        showCancelButton: false,
        confirmButtonText: 'Close',
      });

      curBtn.attr('disabled', false);
      KTApp.unblock('body');
    } else {
      $.ajax({
        url: BASE_URL + 'Expo/exportConsultationList',
        method: 'POST',
        data: {
          id: $('[name="eventID"]').val(),
        },
        xhrFields: {
          responseType: 'blob',
        },
        success: function (data) {
          Swal.fire({
            html: 'Data Exported!',
            icon: 'success',
            showCancelButton: false,
            confirmButtonText: 'Close',
          });

          curBtn.attr('disabled', false);
          KTApp.unblock('body');

          var a = document.createElement('a');
          var url = window.URL.createObjectURL(data);
          a.href = url;
          a.download = 'Expo Consultation List.xlsx';
          document.body.append(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);
        },
        error: function (data) {
          Swal.fire({
            title: 'Network Problem Detected!',
            html: 'Cannot create file, please try again later!',
            icon: 'error',
            showCancelButton: false,
            confirmButtonText: 'Close',
          });

          curBtn.attr('disabled', false);
          KTApp.unblock('body');
        },
      });
    }
  });

  $(document).on('click', '.btn-export-consultations', function () {
    let curBtn = $(this);

    KTApp.block('body', {
      opacity: 0.1,
      state: 'primary',
      message: 'Compiling Data...',
    });

    curBtn.attr('disabled', true);

    $.ajax({
      url: BASE_URL + 'Expo/exportSingularConsultation',
      method: 'POST',
      data: {
        id: curBtn.attr('data-id'),
        uniID: curBtn.attr('data-uni'),
        name: curBtn.attr('data-name'),
      },
      xhrFields: {
        responseType: 'blob',
      },
      success: function (data) {
        Swal.fire({
          html: 'Data Exported!',
          icon: 'success',
          showCancelButton: false,
          confirmButtonText: 'Close',
        });

        curBtn.attr('disabled', false);
        KTApp.unblock('body');

        var a = document.createElement('a');
        var url = window.URL.createObjectURL(data);
        a.href = url;

        a.download = `Expo Consultation List - ${$('input[name="nama_event"]').val()} - ${curBtn.attr('data-name')}.xlsx`;
        document.body.append(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      },
      error: function (data) {
        Swal.fire({
          title: 'Network Problem Detected!',
          html: 'Cannot create file, please try again later!',
          icon: 'error',
          showCancelButton: false,
          confirmButtonText: 'Close',
        });

        curBtn.attr('disabled', false);
        KTApp.unblock('body');
      },
    });
  });
};

const initEventListenerTwo = () => {
  // Copy file pas di klik
  $(document).on('click', '.btn-cpy', function () {
    // Copy link ke clipboard
    let curLink = $(this).parent().siblings().children();
    navigator.clipboard.writeText($(curLink).val());

    // Munculin tooltip
    let curTooltip = $(this).siblings('.custom-tooltip');
    curTooltip.css('display', 'inline');
    curTooltip.fadeOut(1600);
  });

  $(document).on('click', '.btn-edit-invoice', function () {
    console.log('TRIGGER');
    let curBtn = $(this);
    $.post(
      BASE_URL + 'C_Event/getPaymentDetails',
      {
        curID: curBtn.attr('data-id'),
        curPackage: getUrlParameter('id'),
      },
      function (resp) {
        if (resp.code == 200) {
          $('#editPaymentModal input[name="paymentID"]').val(curBtn.attr('data-id'));
          $('#editPaymentModal select[name="editPaymentType"]').val(resp.data.TYPE_EVENT);
          $('#editPaymentModal select[name="editPaymentType"]').selectpicker('refresh');
          $('#editPaymentModal input[name="editPaymentDue"]').val(resp.data.END_DATE);
          $('#editPaymentModal textarea[name="editPaymentDetails"]').val(resp.data.DESCRIPTION);

          let curLink = 'No file...';
          if (resp.data.FILE) {
            // Generate file Links
            curLink = $('<a></a>')
              .attr({
                href: `${s3Path}/Events/${getUrlParameter('id')}/${resp.data.FILE}`,
                target: '_blank',
              })
              .text(`${resp.data.FILE.length > 10 ? resp.data.FILE.substring(0, 10) + '...' : resp.data.FILE}`);
          }
          $('#editPaymentModal #paymentFiles').html(curLink);
          $('#editPaymentModal').modal('show');
        } else {
          Swal.fire({
            title: 'Process Failed',
            html: 'Invalid payment details, please try again',
            icon: 'success',
            showCancelButton: false,
            confirmButtonText: 'Close',
          });
        }
      }
    );
  });

  $(document).on('click', '.btn-view-itineraries', function () {
    let curBtn = $(this);
    $.post(
      BASE_URL + 'Expo_Packages/getItineraries',
      {
        id: curBtn.attr('data-id'),
      },
      function (resp) {
        if (resp.code == 204) {
          Swal.fire({
            title: 'Invalid Actions',
            text: 'Itineraries details not found, please try again later',
            icon: 'error',
            showCancelButton: false,
            confirmButtonText: 'Close',
          });
        } else {
          $('.dynamic-contents').remove();
          $('#itineraryBody').append(resp);
          $('#viewItinerariesModal').modal('show');
        }
      }
    );
  });

  $(document).on('click', '.btnViewPicData', function (e) {
    e.preventDefault();
    let splitName,
      splitEmail,
      splitPhone,
      curString = '',
      picID = $(this).data('pic-id'),
      picName = $(this).data('pic-name'),
      picEmail = $(this).data('pic-email'),
      picPhone = $(this).data('pic-phone'),
      itineraryStatus = $(this).data('itinerary-status');

    if (!splitable(picID.toString(), ';')) {
      splitPhone = picPhone == null ? '-' : picPhone.replace(/[+ _-]/g, '');
      curString += `
        <div class="row" style="font-size: 12px;">
            <div class="col-4">
                <input type="hidden" name="contact[id][]" value="${picID == null ? '-' : picID}" />
                <label class="col-form-label font-weight-bold">Name</label>
                <input type="text" class="form-control" name="contact[name][]" value="${picName == null ? '-' : picName}" />
            </div>
            <div class="col-4">
                <label class="col-form-label font-weight-bold">Email</label>
                <input type="text" class="form-control" name="contact[email][]" value="${picEmail == null ? '-' : picEmail}" />
            </div>
            <div class="col-4">
                <label class="col-form-label font-weight-bold">Number <a href="https://api.whatsapp.com/send?phone=${splitPhone}" target="_blank" class="font-weight-bolder text-primary fas fa-external-link-alt ms-2"></a></label>
                <input type="text" class="form-control" name="contact[phone][]" value="${splitPhone}" />
            </div>
        </div>`;
    } else {
      splitName = picName.split(';');
      splitEmail = picEmail.split(';');
      splitPhone = picPhone.split(';');
      let splitID = picID.toString().split(';');
      curString += `<div class="row" style="font-size: 12px;">`;

      for (let i = 0; i < splitID.length; i++) {
        let curPhone = splitPhone[i] == null ? '-' : splitPhone[i].replace(/[+ _-]/g, '');
        curString += `
            <div class="col-4 mb-2">
                <input type="hidden" name="contact[id][]" value="${splitID[i] == null ? '-' : splitID[i]}" />
                <label class="col-form-label font-weight-bold">Name</label>
                <input type="text" class="form-control" name="contact[name][]" value="${splitName[i] == null ? '-' : splitName[i]}" />
            </div>
            <div class="col-4 mb-2">
                <label class="col-form-label font-weight-bold">Email</label>
                <input type="text" class="form-control" name="contact[email][]" value="${splitEmail[i] == null ? '-' : splitEmail[i]}" />
            </div>
            <div class="col-4 mb-2">
                <label class="col-form-label font-weight-bold">Number <a href="https://api.whatsapp.com/send?phone=${curPhone}" target="_blank" class="font-weight-bolder text-primary fas fa-external-link-alt ms-2"></a></label>
                <input type="text" class="form-control" name="contact[phone][]" value="${splitPhone[i]}" />
            </div>`;
      }
      curString += `</div>`;
    }

    $('#optionalMessage').html(itineraryStatus ?? '');
    $('#picBody').html(curString);
    $('#viewPicContact').modal('show');
  });

  $('.btn-delete-promo').on('click', function () {
    Swal.fire({
      title: 'Delete current promo',
      html: 'Are you sure you want to delete this promo? This process <strong>cannot be reversed</strong>!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Delete',
      cancelButtonText: 'Close',
    }).then((result) => {
      if (result.value) {
        $.post(
          BASE_URL + 'Expo_Packages/deletePromo',
          {
            id: getUrlParameter('id'),
          },
          function (resp) {
            location.reload();
          }
        );
      }
    });
  });

  $('#filter_status_do').on('change', function (e) {
    e.preventDefault();

    let param = {
      sorting: 'no-sorting',
      event_id: getUrlParameter('id'),
    };
    param.status = $(this).val();
    $('#dt_design_order').data('param', param);

    if (param.status !== '') {
      $(`#dt_design_order`).DataTable().draw();
    }
  });

  $('#form_pic_contact').on('submit', function (e) {
    e.preventDefault();

    makeKTBlock('#form_pic_contact');
    $('#btnSubmitPicContact').attr('disabled', true);
    $('#btnSubmitPicContact').text('Please wait...');

    $.ajax({
      url: `${BASE_URL}Expo/updatePicContact`,
      method: $(this).attr('method'),
      dataType: 'json',
      data: $(this).serialize(),
      success: function (response) {
        $('#btnSubmitPicContact').attr('disabled', false);
        $('#btnSubmitPicContact').text('Save');
        makeKTBlock('#form_pic_contact', 'hide');
        makeSwal(response.header, response.message, response.status);
        $('#viewPicContact').modal('hide');
        universityList.reload();
      },
      error: function (data) {
        $('#btnSubmitPicContact').attr('disabled', false);
        $('#btnSubmitPicContact').text('Save');
        makeKTBlock('#form_pic_contact', 'hide');
        makeSwal(data.statusText, data.responseText, 'error');
      },
    });
  });
};

export { initEventListenerOne, initEventListenerTwo };
